import { Card, Row, Col } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import PropertyPicker from './components/PropertyPicker';
import { connect } from 'react-redux';
import BaseFeature from './BaseFeature';
import { END_OF_LIFE } from '../../../../../../utils/constantFeatures';
import { Trans } from 'react-i18next';

class EndOfLife extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[END_OF_LIFE.enable].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === END_OF_LIFE.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    render() {

        const eolEn = this.props.properties[END_OF_LIFE.enable];
        const eolTi = this.props.properties[END_OF_LIFE.time];

        return (
            <Row>
                <Col sm={5} md={3} lg={2} style={{ minWidth: '400px' }}>
                    <Card className={this.getClassName([eolEn, eolTi])} style={{ width: '100%' }}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="End_Life" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={eolEn}
                                title={eolEn.info.displayName}
                                handleChange={this.handleChange} />
                            <PropertyPicker
                                disabled={!this.state.isEnabled}
                                property={eolTi}
                                inputPadding={'padding-none'}
                                title={eolTi.info.displayName}
                                measureUnit={'kh'}
                                min={eolTi.valueMeta.min}
                                max={eolTi.valueMeta.max}
                                titleSize={9}
                                unitSize={1}
                                inputSize={2}
                                inputStyle={{ padding: "0", maxWidth: "auto" }}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EndOfLife);
